import { jsx } from "react/jsx-runtime";
import Price from "@ingka/price";
import cx from "classnames";
const ComparisonPrice = (props) => {
  const { prefix = "", className } = props;
  const baseClass = `${prefix}price-module`;
  const classes = cx(`${baseClass}__comparison-price`, className);
  return /* @__PURE__ */ jsx("span", { className: classes, children: /* @__PURE__ */ jsx(Price, { size: "small", strikeoutPrice: true, fixedSize: true, prefix, ...props }) });
};
var ComparisonPrice_default = ComparisonPrice;
export {
  ComparisonPrice,
  ComparisonPrice_default as default
};
